import { IPageProps, IParamsId, IParamsType } from 'types'
import { PageHeader, ReturnButton, Spinner } from 'components'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { useEffect, useState } from 'react'
import toast from 'core/toast'
import { useNavigate, useParams } from 'react-router-dom'
import ApplicationLogsDetails from './ApplicationLogsDetails'
import { ApplicationLogDto } from 'generated/v1/v1IntegrationsApi'

export interface IParams extends IParamsType {
    id: string,
    indexName: string
}

const ApplicationLogsDetailsPage = ({ title }: IPageProps) => {
    const { id, indexName } = useParams<IParamsId>()

    const navigate = useNavigate()
    const [log, setLog] = useState<ApplicationLogDto>()

    const redirectUrl = '/logs/application-logs'

    const fetch = async () => {
        if (!id) {
            navigate(redirectUrl)
            return
        }

        if (!indexName) {
            navigate(redirectUrl)
            return
        }

        try {
            const result = await V1ApiIntegrationsClient.getApplicationLog(indexName, id)
            setLog(result)
        }
        catch (e) {
            toast.responseErrors(e)
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    return (
        <div id='ApplicationLogsDetailsPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl={redirectUrl} />
            </PageHeader>

            {!log
                ? <Spinner center />
                : <ApplicationLogsDetails log={log} />
            }
        </div>
    )
}
export default ApplicationLogsDetailsPage